import React from "react";
import { getVaiyansDisplay } from "../utils/vaiyansDisplay.js";

const VAIYANS_ICON_SRC = "/Vaiyans.png";

/** Vaiyans.png is white/transparent, so it needs its own contrast tile.
 *  Size matches other table type icons (Mugshot / 4Ocean / V3Tax): h-5 w-5. */
export function VaiyansIcon({ className = "" }) {
  return (
    <span
      className={`relative mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center overflow-hidden rounded-[22%] bg-slate-950 ring-1 ring-slate-200/70 ${className}`}
      style={{ WebkitPrintColorAdjust: "exact", printColorAdjust: "exact" }}
      aria-hidden="true"
    >
      <img
        src={VAIYANS_ICON_SRC}
        alt=""
        className="h-[14px] w-[14px] object-contain"
        loading="lazy"
        decoding="async"
        draggable={false}
        onError={(event) => {
          event.currentTarget.style.display = "none";
        }}
      />
    </span>
  );
}

export default function VaiyansTypeLabel({
  classification,
  leading = null,
  className = "",
}) {
  const display = getVaiyansDisplay(classification);
  if (!display) return null;

  return (
    <span
      className={`inline-flex min-w-0 items-start gap-2 text-left font-semibold text-blue-600 ${className}`}
    >
      {leading ? (
        <span className="mt-0.5 flex-shrink-0" aria-hidden="true">
          {leading}
        </span>
      ) : null}
      <VaiyansIcon />
      <span className="min-w-0 leading-tight">
        <span className="block whitespace-normal break-words">
          {display.title}
        </span>
        <span className="block whitespace-normal break-words text-[11px] font-medium text-blue-700/90">
          {display.subtitle}
        </span>
      </span>
    </span>
  );
}
